import { useEffect, useState } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useISList = () => {
  const [isList, setIsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchISList = async () => {
      try {
  const { data } = await axiosApi.get('/nis/is-list');
  setIsList(data);
      } catch (err) {
        console.error('Error fetching IS list:', err);
        setError('Failed to load IS list');
      } finally {
        setLoading(false);
      }
    };

    fetchISList();
  }, []);

  return { isList, loading, error };
};

export default useISList;